export const createSpan = (className, text = ``) => {
  const span = document.createElement(`span`);
  span.className = className;
  span.innerHTML = text;

  return span;
};
